<script lang="ts">
  import { assets } from "$app/paths";

  export let countryCode = "";
  export let country = "";
</script>

<style lang="scss">
  .flag {
    display: block;
    background-color: $on-surface-10;
    box-shadow: 0 0 8px $on-surface-10;
    width: 1em;
    aspect-ratio: 4 / 3;
  }

  .caption {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }
</style>

<svg class="flag">
  <use
    href={`${assets}/flags/flag-sprite.v2.svg#${countryCode.toLowerCase()}`}
  />
  <p class="caption">{country} flag</p>
</svg>
